export enum SearchProgressStage {
    None,
    PollingSuppliers,
    LookingForMore,
    ContinuingPolling,
    AllPolled
}
